var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[(_vm.loading)?_c('v-col',{attrs:{"cols":"12"}},[_c('v-skeleton-loader',{attrs:{"type":"image"}})],1):_c('v-col',{staticClass:"py-0",attrs:{"cols":"12"}},[_c('chart-card',{attrs:{"title":_vm.formatTitle,"subtitle":_vm.formatSubtitle,"display-mode":"","data":_vm.chartData,"loader":"charts-comparativo","controls":false,"legends":"","chartHeight":180,"chartClass":"elevation-0","is-integer":_vm.isIndicatorInteger,"configUpdate":{
        responsive: true,
        maintainAspectRatio: false,
        legend: { display: false },
        hover: { mode: true },
      }}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }